import { render, staticRenderFns } from "./IconMenuFolders.vue?vue&type=template&id=5becf790&"
import script from "./IconMenuFolders.vue?vue&type=script&lang=js&"
export * from "./IconMenuFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5becf790')) {
      api.createRecord('5becf790', component.options)
    } else {
      api.reload('5becf790', component.options)
    }
    module.hot.accept("./IconMenuFolders.vue?vue&type=template&id=5becf790&", function () {
      api.rerender('5becf790', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconMenuFolders.vue"
export default component.exports